// SR-CUSTOM (31 Oct 2026): "Complete the room" — the matching wall hook for an Ensemble handle.
// The cart drawer and cart page render the suggestion in Liquid (snippets/sr-hook-match.liquid). This script:
//  - handles Add / No thanks clicks for every suggestion (delegated, survives the drawer's re-render),
//  - adds the same suggestion to the theme's "Added to cart" pop-up and the Design Your Own pop-up,
//    by looking up the hook (and its Pack of 3) for the handle that was just added.
// "No thanks" hides that hook's suggestion for the rest of the browser session.
(function () {
  if (window.SRHookMatch) return;
  var KEY = 'sr-hm-no';
  function noList() { try { return JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function addNo(hk) { var l = noList(); if (l.indexOf(hk) < 0) l.push(hk); try { sessionStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }
  function hideDismissed(root) {
    var l = noList();
    (root || document).querySelectorAll('[data-sr-hookmatch]').forEach(function (el) { if (l.indexOf(el.getAttribute('data-sr-hookmatch')) >= 0) el.hidden = true; });
  }
  function money(c) { try { return Woolman.Utils.formatMoney(c); } catch (e) { return '$' + (c / 100).toFixed(2); } }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function track(name, p) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, p || {}); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, p || {}); } catch (e) {}
  }
  function getJSON(u) { return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function hookHandleFor(handle) {
    var m = String(handle || '').replace(/-ensemble-handle$/, '');
    if (m === handle) return null;
    if (m === 'aged-bronze') m = 'bronze';
    return m + '-ensemble-hook';
  }
  function refreshCart() {
    return getJSON('/cart.js').then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      document.querySelectorAll('.cart-button').forEach(function (b) { b.classList.toggle('has-count-visible', cart.item_count > 0); });
      document.dispatchEvent(new CustomEvent('cart:update', { detail: Object.assign({ cart: cart }, cart) }));
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      var items = document.querySelector('#drawer-cart cart-items');
      if (items && items.renderAndShowItems) items.renderAndShowItems(false);
    });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-sr-hm-add]');
    var no = e.target.closest && e.target.closest('[data-sr-hm-no]');
    if (no) {
      e.preventDefault();
      var box = no.closest('[data-sr-hookmatch]');
      if (box) { addNo(box.getAttribute('data-sr-hookmatch')); box.hidden = true; track('sr_hook_match_dismiss', { hook: box.getAttribute('data-sr-hookmatch') }); }
      return;
    }
    if (!add || add.disabled) return;
    e.preventDefault();
    var boxA = add.closest('[data-sr-hookmatch]');
    boxA.querySelectorAll('[data-sr-hm-add]').forEach(function (b) { b.disabled = true; });
    var label = add.innerHTML;
    add.textContent = 'Adding…';
    fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: +add.getAttribute('data-sr-hm-add'), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
      .then(function () {
        track('sr_hook_match_add', { hook: boxA.getAttribute('data-sr-hookmatch'), variant: add.getAttribute('data-sr-hm-add') });
        boxA.innerHTML = '<p class="sr-hm__done">Added to your cart</p>';
        return refreshCart();
      })
      .catch(function (err) {
        add.innerHTML = label;
        boxA.querySelectorAll('[data-sr-hm-add]').forEach(function (b) { b.disabled = false; });
        var p = boxA.querySelector('.sr-hm__err') || boxA.appendChild(Object.assign(document.createElement('p'), { className: 'sr-hm__err' }));
        p.textContent = err.message;
      });
  });

  // Build the suggestion for a pop-up from the store's product JSON
  function buildBox(hk, finish, inCart) {
    if (noList().indexOf(hk) >= 0) return Promise.resolve(null);
    if (inCart.some(function (h) { return h === hk || h === hk + '-pack-of-3'; })) return Promise.resolve(null);
    return getJSON('/products/' + hk + '.js').then(function (hook) {
      var hv = hook.variants.filter(function (v) { return v.title === finish; })[0];
      // No suggestion for Matte Black / Matte White buttons (no matching hook) or an out-of-stock hook (David, 31 Oct)
      if (!hv || !hv.available) return null;
      var packP = hv ? getJSON('/products/' + hk + '-pack-of-3.js').catch(function () { return null; }) : Promise.resolve(null);
      return packP.then(function (pack) {
        var pv = pack && pack.variants.filter(function (v) { return v.title === finish; })[0];
        var trade = !!window.SRHM_TRADE;
        var single = hv ? (trade ? Math.floor(hv.price * 75 / 100) : hv.price) : 0;
        var packPrice = pv ? (trade ? Math.floor(hv.price * 75 / 100) * 3 : pv.price) : 0;
        var img = (hv && hv.featured_image && hv.featured_image.src) || hook.featured_image;
        if (img) img = (img.indexOf('//') === 0 ? 'https:' + img : img) + (img.indexOf('?') >= 0 ? '&' : '?') + 'width=160';
        var el = document.createElement('div');
        el.className = 'sr-hm sr-hm--pop';
        el.setAttribute('data-sr-hookmatch', hk);
        el.innerHTML = '<p class="sr-hm__eyebrow">Complete the room</p><div class="sr-hm__row">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64">' : '') +
          '<div class="sr-hm__txt"><b>' + esc(hook.title) + '</b><span>' + esc(finish) + ' button, to match your handles</span></div></div>' +
          '<div class="sr-hm__btns">' +
          '<button type="button" class="btn btn--secondary size--small" data-sr-hm-add="' + hv.id + '">Add hook · ' + esc(money(single)) + '</button>' +
          (pv && pv.available ? '<button type="button" class="btn btn--secondary size--small" data-sr-hm-add="' + pv.id + '">Pack of 3 · ' + esc(money(packPrice)) + '</button>' : '') +
          '</div><button type="button" class="sr-hm__no" data-sr-hm-no>No thanks</button>';
        track('sr_hook_match_view', { hook: hk, place: 'popup' });
        return el;
      });
    }).catch(function () { return null; });
  }

  // After any add to cart: if the newest cart line is an Ensemble handle, add the suggestion to whichever pop-up is showing
  document.addEventListener('ajaxProduct:added', function () {
    getJSON('/cart.js').then(function (cart) {
      var line = cart.items[0];
      if (!line) return;
      var hk = hookHandleFor(line.handle);
      if (!hk) return;
      var fin = '';
      (line.options_with_values || []).forEach(function (o) { if (o.name === 'Detail Finish') fin = o.value; });
      var handles = cart.items.map(function (i) { return i.handle; });
      return buildBox(hk, fin, handles).then(function (box) {
        if (!box) return;
        var tries = 0;
        (function place() {
          var note = document.querySelector('.cart-notification');
          var dyo = document.querySelector('.dyo-modal[data-modal]:not([hidden]) .dyo-dialog');
          var target = note ? note.querySelector('.cart-notification-buttons') : (dyo ? dyo.querySelector('.dyo-actions') : null);
          if (target) {
            var old = target.parentNode.querySelector('.sr-hm--pop'); if (old) old.remove();
            target.parentNode.insertBefore(box, target);
            return;
          }
          if (++tries < 20) setTimeout(place, 150);
        })();
      });
    }).catch(function () {});
  });

  // Hide dismissed suggestions in the drawer/cart page, including after each re-render
  hideDismissed();
  var queued = false;
  new MutationObserver(function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; hideDismissed(); }); }).observe(document.documentElement, { childList: true, subtree: true });
  window.SRHookMatch = { hookHandleFor: hookHandleFor };
})();
